module.exports = __webpack_public_path__ + "img/lasource-28.e176c81a.jpg";